import number from "@/helpers/number";
import { Link, useForm } from "@inertiajs/inertia-react";
import React, { useEffect, useMemo, useState } from "react";
import Button from "../Button";
import Table from "../Table";
import classNames from 'classnames';
import Swal from "sweetalert2";
import { formatDate } from "@/helpers/date"
import axios from "axios";
import { toast } from "react-toastify";
import Spinner from "../Spinner";
import ExportButton from "../ExportButton";
import RemoveExportButton from "../Export/RemoveExportButton";
import ExportTable from "@/Pages/Export/Sales/Table";
import { Inertia } from "@inertiajs/inertia";

const BulkSaleCard = ({
    id,
    company_name,
    contact_full_name,
    email,
    rut,
    telephone,
    payment_mode,
    ticket_quantity,
    ticket_price,
    schedule_type_duration,
    expiration_at,
    export_requests,
    is_weekend
}) => {
    const [isShowingDetails, setIsShowingDetails] = useState(false);
    const [loadingScheduling, setLoadingScheduling] = useState(false);
    const [jobId, setJobId] = useState(null);
    const [isChecking, setIsChecking] = useState(false)

    const { delete: _delete, get } = useForm();

    const handleDelete = () => {
        Swal.fire({
            title: '¿Estas seguro de que quieres borrar esta venta empresa?',
            icon: 'warning',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: "Si, estoy seguro",
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#22a0d9',
            customClass: {
                confirmButton: 'bg-gray-900'
            }
        })
        .then((result) => {
            if (result.isConfirmed) {
                _delete(route("bulk-sales.delete", id));
            }
        })
    };

    const handleDownloadExcel = () => {
        window.open(route('bulk-sales.export-orders', { bulkSale: id }), '_blank');
    }

    useEffect(() => {
        if (!jobId) return;
        setIsChecking(true);

        const interval = setInterval(async () => {
            try {
                const response = await axios.get(route('export.request.check', { uuid: jobId }));
                if (response.data.status === 'success') {
                    const messages = {
                        'exportation.completed': 'El reporte se generó correctamente.',
                    }

                    const message = messages[response.data.code];
                    toast.success(message);
                    setJobId(null);

                    if (response.data.code === 'exportation.completed') {
                        clearInterval(interval)
                        Inertia.reload({ only: ['bulkSales'] })
                        setIsChecking(false);
                    }
                }
            } catch (error) {
                console.log({error});
                setIsChecking(false);
            }
        }, 5000);
    }, [jobId]);

    const linkIsAvailable = useMemo(() => {
        return !loadingScheduling && !isChecking;
    }, [loadingScheduling, isChecking]);

    const handleDownloadTicketsQR = async () => {
        if (!linkIsAvailable) return;
        setLoadingScheduling(true);

        try {
            const response = await axios.post(route('bulk-sales.export-tickets-qr', { bulkSale: id }));
            if (response.data.status === 'success') {
                const messages = {
                    'exportation.scheduled': 'El reporte se está generando.',
                }

                const message = messages[response.data.code];
                toast.success(message);

                setJobId(response.data.job_id);
            }
        } catch (error) {
            console.log({error});
            toast.error('Ocurrió un error al generar el reporte.');
        }

        setLoadingScheduling(false);
    }

    const totalByTickets = ticket_quantity * ticket_price;

    const total = totalByTickets;

    const handleShowDetails = () => {
        setIsShowingDetails(!isShowingDetails);
    };

    return (
        <div className="bg-white mb-4 p-4">
            <div className={classNames("flex justify-between items-center flex-col md:flex-row gap-4 md:gap-0", {
                "mb-4": isShowingDetails
            })}>
                <div>
                    <h3 className="text-2xl font-bold text-center md:text-left">{company_name}</h3>
                    <p className="text-center md:text-left">{email}</p>
                    <p className="text-sm text-center md:text-left">Fecha de expiración: {formatDate(expiration_at, "dd 'de' ^LLLL 'de' yyyy")}</p>
                    {/* <p>{contact_full_name}</p> */}
                    {/* <p>{rut}</p> */}
                    {/* <p>{telephone}</p> */}
                    {/* <p>Cantidad de tickets: {ticket_quantity}</p> */}
                    {/* <p>Precio por ticket: {ticket_price}</p> */}
                    {/* <p>Cantidad de calcetines: {socks_quantity}</p> */}
                    {/* <p>Precio por calcetines: {socks_price}</p> */}
                </div>
                <div className="md:hidden lg:block">
                    <h4 className="text-xl font-bold text-center md:text-left">
                        ${number.format(total, 0, "", ".")}
                    </h4>
                </div>
                <div className="md:hidden lg:block">
                    <p className="text-center md:text-left">
                        {payment_mode === "transfer" &&
                            "Pago por transferencia"}
                    </p>
                    <p className="text-center md:text-left">{payment_mode === "cash" && "Pago al contado"}</p>
                </div>

                <div className="flex gap-2 flex-col sm:flex-row items-center">
                    <Button type="button" onClick={handleShowDetails}>
                        {isShowingDetails ? "Ocultar detalles" : "Ver detalles"}
                    </Button>
                    <Button
                        type="button"
                        onClick={handleDownloadExcel}
                    >
                        Descargar excel
                    </Button>
                    <Button
                        processing={!linkIsAvailable}
                        type="button"
                        onClick={handleDownloadTicketsQR}
                        style={{ minWidth: 200, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                        {loadingScheduling ? <Spinner width="1rem" height="1rem" weight={2} color="transparent" backgroundColor="#ffffff" /> : 'Descargar tickets qr'}
                    </Button>
                    <Button className="bg-red-600" onClick={handleDelete}>
                        <svg style={{ fill: '#ffffff' }} className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
                    </Button>
                </div>
            </div>
            <div>
                {
                    isShowingDetails && (
                        <>
                            <div className="px-4 mb-4">
                                <Table
                                    headers={[
                                        "Links",
                                        "Nombre de la empresa",
                                        "Nombre del contacto empresa",
                                        "Número de teléfono empresa",
                                        "R.U.T",
                                        "Periodo de agendamiento",
                                        "Periodo",
                                        "Cantidad de tickets",
                                        "Precio por ticket",
                                        "Precio total por tickets",
                                        "Total",
                                    ]}

                                    items={[
                                        [
                                            <Link href={route('bulk-sales.show', id)}>
                                                <Button type="button">
                                                    Ver tickets
                                                </Button>
                                            </Link>,
                                            company_name,
                                            contact_full_name,
                                            telephone,
                                            rut,
                                            `${schedule_type_duration} ${schedule_type_duration === 1 ? 'hora' : 'horas'}`,
                                            is_weekend ? "Fin de semana" : "Semana",
                                            ticket_quantity,
                                            `$${number.format(ticket_price)}`,
                                            `$${number.format(totalByTickets)}`,
                                            `$${number.format(total)}`,
                                        ]
                                    ]}
                                />
                            </div>

                            {export_requests.length > 0 && (
                                <div>
                                    <div>
                                        <ExportTable title="Ultimos QRs exportados">
                                            <ExportTable.Head>
                                                <ExportTable.Row>
                                                    <ExportTable.Header>Fecha de exportación</ExportTable.Header>
                                                    <ExportTable.Header />
                                                </ExportTable.Row>
                                            </ExportTable.Head>
                                            <ExportTable.Body>
                                                {export_requests.map(({ id, created_at }, index) => (
                                                    <ExportTable.Row key={index}>
                                                        <ExportTable.Data>
                                                            {formatDate(created_at, "dd 'de' ^MMMM 'del' yyyy")} <br />
                                                            {formatDate(created_at, 'HH:mm:ss')}
                                                        </ExportTable.Data>
                                                        <ExportTable.Data>
                                                            <div className="flex items-center justify-end gap-4">
                                                                <ExportButton id={id}>Descargar exporte</ExportButton>
                                                                <RemoveExportButton id={id} />
                                                            </div>
                                                        </ExportTable.Data>
                                                    </ExportTable.Row>
                                                ))}
                                            </ExportTable.Body>
                                        </ExportTable>
                                    </div>
                                </div>
                            )}
                        </>
                    )
                }
            </div>
        </div>
    );
};

export default BulkSaleCard;
